const HAS_DIFFUSE_TEXTURE = 1 << 0;
const HAS_EMISSIVE_TEXTURE = 1 << 1;
const HAS_BUMP_TEXTURE = 1 << 2;
const HAS_SPECULAR_TEXTURE = 1 << 3;
const HAS_AMBIENT_TEXTURE = 1 << 4;
const HAS_LIGHTMAP_TEXTURE = 1 << 5;
const HAS_OPACITY_TEXTURE = 1 << 6;
const LIGHTMAP_USES_UV2 = 1 << 7;
const AMBIENT_USES_UV2 = 1 << 8;
const DOUBLE_SIDED = 1 << 9;
const DIFFUSE_USES_UV2 = 1 << 10;
const SPECULAR_USES_UV2 = 1 << 11;
const OPACITY_FROM_RGB = 1 << 12;
const HAS_REFLECTION_TEXTURE = 1 << 13;
const DISABLE_LIGHTING = 1 << 14;
const MATERIAL_ALPHA_BLEND = 1 << 16;
const HAS_CUBE_REFLECTION = 1 << 17;
const NO_COLOR_OUTPUT = 1 << 18;
const HAS_DEPTH_EMISSIVE_TEXTURE = 1 << 19;
const ESM_SHADOW_OUTPUT = 1 << 20;
const GEOMETRY_OUTPUT = 1 << 21;
const LIGHTMAP_SHADOWMAP = 1 << 15;
const LIGHTMAP_FLIP_V = 1 << 22;
const VERTEX_ALPHA = 1 << 24;
const HAS_SKELETON = 1 << 26;
const HAS_SKELETON_8 = 1 << 27;
const STD_SCENE_FOG = 1 << 0;
let _stdExts = null;
let _stdExtsSorted = null;
function _registerStdExt(ext) {
  (_stdExts ??= /* @__PURE__ */ new Map()).set(ext._id, ext);
  _stdExtsSorted = null;
}
function _getStdExts() {
  return _stdExts ??= /* @__PURE__ */ new Map();
}
function _getStdExtsSorted() {
  if (!_stdExtsSorted) {
    const map = _stdExts;
    _stdExtsSorted = map ? Array.from(map.values()).sort((a, b) => a._id.localeCompare(b._id)) : [];
  }
  return _stdExtsSorted;
}
const NEEDS_UV = HAS_DIFFUSE_TEXTURE | HAS_EMISSIVE_TEXTURE | HAS_BUMP_TEXTURE | HAS_SPECULAR_TEXTURE | HAS_AMBIENT_TEXTURE | HAS_LIGHTMAP_TEXTURE | HAS_OPACITY_TEXTURE;
const NEEDS_UV2 = LIGHTMAP_USES_UV2 | AMBIENT_USES_UV2 | DIFFUSE_USES_UV2 | SPECULAR_USES_UV2;

export { AMBIENT_USES_UV2, DIFFUSE_USES_UV2, DISABLE_LIGHTING, DOUBLE_SIDED, ESM_SHADOW_OUTPUT, GEOMETRY_OUTPUT, HAS_AMBIENT_TEXTURE, HAS_BUMP_TEXTURE, HAS_CUBE_REFLECTION, HAS_DEPTH_EMISSIVE_TEXTURE, HAS_DIFFUSE_TEXTURE, HAS_EMISSIVE_TEXTURE, HAS_LIGHTMAP_TEXTURE, HAS_OPACITY_TEXTURE, HAS_REFLECTION_TEXTURE, HAS_SKELETON, HAS_SKELETON_8, HAS_SPECULAR_TEXTURE, LIGHTMAP_FLIP_V, LIGHTMAP_SHADOWMAP, LIGHTMAP_USES_UV2, MATERIAL_ALPHA_BLEND, NEEDS_UV, NEEDS_UV2, NO_COLOR_OUTPUT, OPACITY_FROM_RGB, SPECULAR_USES_UV2, STD_SCENE_FOG, VERTEX_ALPHA, _getStdExts, _getStdExtsSorted, _registerStdExt };
//# sourceMappingURL=standard-flags.js.map
